module.exports = __webpack_public_path__ + "static/media/option7-4row.e1189a2c.png";